import { History } from "history";
import {
  GENERATE_SEQUENCE_NUMBER,
  GENERATE_SEQUENCE_NUMBER_ERROR,
  GENERATE_SEQUENCE_NUMBER_SUCCESS,
  GenerateSequenceNumberAction,
  GenerateSequenceNumberErrorAction,
  GenerateSequenceNumberSuccessAction,
  GET_APP_SETTINGS,
  GET_APP_SETTINGS_ERROR,
  GET_APP_SETTINGS_SUCCESS,
  GetAppSettingsAction,
  GetAppSettingsErrorAction,
  GetAppSettingsSuccessAction,
  UPDATE_APP_SETTINGS,
  UPDATE_APP_SETTINGS_ERROR,
  UPDATE_APP_SETTINGS_SUCCESS,
  UpdateAppSettingsAction,
  UpdateAppSettingsErrorAction,
  UpdateAppSettingsSuccessAction,
} from "./actionTypes";
import {
  AppSettingsDto,
  GenerateSequenceNumberRequest,
  UpdateAppSettingsRequest,
} from "../../interfaces/app-settings";
import { AppSettingsTypeEnum } from "../../enums";

//#region Get AppSettings

export const getAppSettings = (
  type: AppSettingsTypeEnum,
  history: History
): GetAppSettingsAction => {
  return {
    type: GET_APP_SETTINGS,
    payload: { type, history },
  };
};

export const getAppSettingsSuccess = (
  response: AppSettingsDto
): GetAppSettingsSuccessAction => {
  return {
    type: GET_APP_SETTINGS_SUCCESS,
    payload: response,
  };
};

export const getAppSettingsError = (error: any): GetAppSettingsErrorAction => {
  return {
    type: GET_APP_SETTINGS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update AppSettings

export const updateAppSettings = (
  type: AppSettingsTypeEnum,
  request: UpdateAppSettingsRequest,
  history: History
): UpdateAppSettingsAction => {
  return {
    type: UPDATE_APP_SETTINGS,
    payload: { type, request, history },
  };
};

export const updateAppSettingsSuccess = (
  settings: AppSettingsDto
): UpdateAppSettingsSuccessAction => {
  return {
    type: UPDATE_APP_SETTINGS_SUCCESS,
    payload: settings,
  };
};

export const updateAppSettingsError = (
  error: any
): UpdateAppSettingsErrorAction => {
  return {
    type: UPDATE_APP_SETTINGS_ERROR,
    payload: error,
  };
};

//#endregion

//#region generate sequence number

export const generateSequenceNumber = (
  request: GenerateSequenceNumberRequest
): GenerateSequenceNumberAction => {
  return {
    type: GENERATE_SEQUENCE_NUMBER,
    payload: request,
  };
};

export const generateSequenceNumberSuccess = (
  response: any
): GenerateSequenceNumberSuccessAction => {
  return {
    type: GENERATE_SEQUENCE_NUMBER_SUCCESS,
    payload: response,
  };
};

export const generateSequenceNumberError = (
  error: any
): GenerateSequenceNumberErrorAction => {
  return {
    type: GENERATE_SEQUENCE_NUMBER_ERROR,
    payload: error,
  };
};

//#endregion
